import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { CustomButtonProps } from './types';

export const CustomButton: React.FC<CustomButtonProps> = ({
  variant = 'contained',
  size = 'medium',
  disabled = false,
  loading = false,
  startIcon,
  endIcon,
  sx,
  onClick,
  children,
  ...rest
}) => {
  const getStartIcon = () => {
    if (loading) {
      return <CircularProgress size={16} color="inherit" />;
    }
    return startIcon;
  };

  return (
    <Button
      variant={variant}
      size={size}
      disabled={disabled || loading}
      startIcon={getStartIcon()}
      endIcon={endIcon}
      onClick={onClick}
      sx={sx}
      {...rest}
    >
      {children}
    </Button>
  );
};
